<template>
<div class="con-menu">
  <div class="menu sticky-container">
   <span class="cont-back">
     <a href="#" class="btn btn-outline-secondary btn-sm back" @click="goBack">⏴-</a>
   </span>
    <!-- Modal -->
<div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ selectedNome ? selectedNome : $t('modifiche_piatto') }}</h5>
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body text-start">
        <div v-if="add && add.length" class="mb-3">
          <h6 class="fw-bold text-primary mb-2 d-flex align-items-center gap-2">
            <i class="fas fa-plus-circle"></i> {{ $t('aggiunte_possibili') }}
          </h6>
          <div class="d-flex flex-column gap-2 ms-1">
            <div v-for="(ad, index) in getSortedItems(add)" :key="getOptionKey(ad, index)" class="form-check custom-touch-check">
              <input 
                type="checkbox" 
                v-model="aggiunte" 
                class="form-check-input" 
                :id="'add-check-' + index" 
                :name="'add-' + index" 
                :value="ad"
              />
              <label class="form-check-label ms-2 pointer" :for="'add-check-' + index">
                {{ getItemLabel(ad) }}
              </label>
            </div>
          </div>
        </div>

        <div v-if="remove && remove.length" class="mb-3">
          <h6 class="fw-bold text-danger mb-2 d-flex align-items-center gap-2">
            <i class="fas fa-minus-circle"></i> {{ $t('possono_togliere') }}
          </h6>
          <div class="d-flex flex-column gap-2 ms-1">
            <div v-for="(rem, index) in getSortedItems(remove)" :key="getOptionKey(rem, index)" class="form-check custom-touch-check">
              <input 
                type="checkbox" 
                v-model="senza" 
                class="form-check-input" 
                :id="'rem-check-' + index" 
                :name="'rem-' + index" 
                :value="rem"
              />
              <label class="form-check-label ms-2 pointer" :for="'rem-check-' + index">
                {{ getItemLabel(rem) }}
              </label>
            </div>
          </div>
        </div>

        <div class="mt-3">
          <label class="form-label fw-bold d-flex align-items-center gap-2">
            <i class="fas fa-edit"></i> {{ $t('nota', 'Nota') }}
          </label>
          <textarea v-model="notaModal" class="form-control" rows="2" :placeholder="$t('scrivi_nota', 'Inserisci una nota...')"></textarea>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-success" data-bs-dismiss="modal" @click="createOrdineFromModal">{{ $t('aggiungi') }}</button>
      </div>
    </div>
  </div>
</div>

  <!-- Modal Riepilogo Ordine Full Screen -->
  <div v-if="showSummaryModal" class="fullscreen-order-modal-backdrop">
    <div class="fullscreen-order-modal">
      <!-- Header -->
      <div class="fullscreen-modal-header">
        <div class="header-title">
          <i class="fas fa-clipboard-check me-2"></i>
          <h2>{{ $t('riepilogo_ordine', 'Riepilogo Ordine') }}</h2>
        </div>
        <div class="header-info-badges">
          <span class="info-badge" v-if="getTableInfo().sala"><i class="fas fa-door-open me-1"></i> Sala: <strong>{{ getTableInfo().sala }}</strong></span>
          <span class="info-badge" v-if="getTableInfo().tavolo"><i class="fas fa-chair me-1"></i> Tavolo: <strong>{{ getTableInfo().tavolo }}</strong></span>
          <span class="info-badge" v-if="getTableInfo().coperti"><i class="fas fa-users me-1"></i> Coperti: <strong>{{ getTableInfo().coperti }}</strong></span>
          <span class="info-badge delivery" v-if="selectedDelivery"><i class="fas fa-motorcycle me-1"></i> {{ selectedDelivery }}</span>
        </div>
        <button type="button" class="btn-close-modal" @click="closeOrderSummary" aria-label="Close">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <!-- Body -->
      <div class="fullscreen-modal-body">
        <div v-if="ordine.length === 0" class="empty-order-msg">
          <i class="fas fa-shopping-basket fa-3x mb-3 text-muted"></i>
          <p>{{ $t('nessun_piatto_in_ordine', 'Nessun piatto nell\'ordine') }}</p>
        </div>

        <div v-else class="order-items-list">
          <div v-for="(item, index) in ordine" :key="index" class="order-summary-card">
            <div class="item-main-info">
              <div class="item-course-badge">{{ item.ordine || '1°' }}</div>
              <div class="item-details">
                <h4 class="item-name">{{ item.piatto }}</h4>
                <div class="item-customizations">
                  <span class="additions-tag" v-if="item.aggiunta && item.aggiunta.length">
                    <i class="fas fa-plus-circle me-1"></i> +{{ item.aggiunta.map(a => a.descrizione || a).join(', ') }}
                  </span>
                  <span class="removals-tag" v-if="item.senza && item.senza.length">
                    <i class="fas fa-minus-circle me-1"></i> -{{ Array.isArray(item.senza) ? item.senza.join(', ') : item.senza }}
                  </span>
                </div>
                <div class="item-note-input mt-2">
                  <input 
                    type="text" 
                    v-model="item.nota" 
                    class="form-control form-control-sm" 
                    :placeholder="$t('scrivi_nota', 'Aggiungi / modifica nota al piatto...')"
                  />
                </div>
              </div>
              
              <div class="item-quantity-controls">
                <button class="btn-qty" @click="decrementQuantity(index)">-</button>
                <span class="qty-display">{{ item.quantita }}</span>
                <button class="btn-qty" @click="incrementQuantity(index)">+</button>
              </div>

              <div class="item-pricing">
                <div class="unit-price">{{ item.prezzo }} € / cad</div>
                <div class="total-price">{{ (item.prezzo * item.quantita).toFixed(2) }} €</div>
              </div>

              <button class="btn-delete-item" @click="deleteP(index)" title="Elimina piatto">
                <i class="fas fa-trash-alt"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="fullscreen-modal-footer">
        <div class="order-grand-total">
          <div class="total-label">{{ $t('totale_ordine', 'Totale Ordine') }} ({{ getOrderItemsCount() }} elementi):</div>
          <div class="total-amount">{{ getOrderTotal().toFixed(2) }} €</div>
        </div>
        <div class="action-buttons">
          <button type="button" class="btn-cancel" @click="closeOrderSummary">
            <i class="fas fa-arrow-left me-2"></i> {{ $t('annulla', 'Torna al Menu') }}
          </button>
          <button type="button" class="btn-submit-order" @click="confermaEInviaOrdine" :disabled="ordine.length === 0">
            <i class="fas fa-paper-plane me-2"></i> {{ $t('ordina', 'Ordina') }}
          </button>
        </div>
      </div>
    </div>
  </div>
    <div class="order v-sticky" :sticky-offset="offset" sticky-side="right" v-if="tok">
      <span @click="()=> displayOrdine = !displayOrdine">{{ $t('ordinazione') }}</span><br/>
      <div class="check-cont">
        <div class="form-check">
          <input class="form-check-input" type="radio" name="flexRadioDefault" id="antipasti-radio" v-model="checked" value="1°" checked>
            <label class="form-check-label" for="antipasti-radio">
            {{ $t('portata_1') }}
            </label>
        </div>
        <div class="form-check">
        <input class="form-check-input" type="radio" name="flexRadioDefault" id="primi-radio" v-model="checked"  value="2°">
        <label class="form-check-label" for="primi-radio">
        {{ $t('portata_2') }}
        </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="radio" name="flexRadioDefault" id="secondi-radio" v-model="checked" value="3°">
          <label class="form-check-label" for="secondi-radio">
          {{ $t('portata_3') }}
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="radio" name="flexRadioDefault" id="quarta-radio" v-model="checked" value="4°">
          <label class="form-check-label" for="quarta-radio">
          {{ $t('portata_4') }}
          </label>
        </div>
      </div>
      <div class="vis-ordine" v-if="displayOrdine">
        <div class="mb-2 text-center">
          <a href="#" class="btn btn-outline-success btn-sm w-100 fw-bold" @click.prevent="openOrderSummary">{{ $t('conferma_ordine') }}</a>
        </div>
        <!-- Piattaforme Delivery selection -->
        <div class="delivery-selection mb-3 p-2 bg-light rounded border text-start" v-if="deliveryPlatforms && deliveryPlatforms.length > 0">
          <div class="fw-bold mb-1 small text-dark">Piattaforma Delivery (Opzionale):</div>
          <div class="d-flex flex-wrap gap-1">
            <button 
              v-for="platform in deliveryPlatforms" 
              :key="platform.nome" 
              type="button"
              class="btn btn-sm"
              :class="selectedDelivery === platform.nome ? 'btn-primary text-white fw-bold' : 'btn-outline-primary'"
              @click.prevent="selectDelivery(platform.nome)"
            >
              {{ platform.nome }}
              <span v-if="selectedDelivery === platform.nome" class="ms-1">✓</span>
            </button>
          </div>
          <div v-if="selectedDelivery" class="mt-1 small text-primary fw-bold">
            Selezionato: {{ selectedDelivery }}
          </div>
        </div>

        <div class="riepilogo" v-for="(o,ind) in ordine" :key="ind">
          <div class="con-piatti">
          <a href="#" class="btn btn-outline-warning btn-sm" @click="(e)=>deleteP(ind)">Delete</a>
          <div class="nome">{{o.ordine}},</div>
          <div class="nome">{{o.piatto}},</div>
          <div class="aggiunte" v-if="o.aggiunta && o.aggiunta.length">+{{getSortedItems(o.aggiunta).map(a => getItemLabel(a)).join(', ')}}</div>
          <div class="senza" v-if="o.senza && o.senza.length">-{{getSortedItems(o.senza).map(s => getItemLabel(s)).join(', ')}}</div>
          <div class="quantita">Qta {{o.quantita}},</div>
          <div class="prezzo-tot">{{ $t('totale') }} {{o.prezzo * o.quantita}} €</div>
          </div>
          <div class="mt-1 px-1">
            <input 
              type="text" 
              v-model="o.nota" 
              class="form-control form-control-sm bg-white text-dark border-secondary" 
              :placeholder="$t('scrivi_nota', 'Aggiungi / modifica nota al piatto...')"
            />
          </div>
        </div>
      </div>
      </div>

    <!-- Category Filter Bar -->
    <div class="category-filter-container">
      <div class="category-filter">
        <div 
          class="category-item" 
          :class="{ active: selectedCategory === 'all' }"
          @click="selectedCategory = 'all'"
        >
          <div class="cat-icon"><i class="fas fa-th-large"></i></div>
          <span class="cat-label">{{ $t('tutti') || 'Tutti' }}</span>
        </div>
        <div 
          v-for="cat in categories" 
          :key="cat.id"
          class="category-item" 
          :class="{ active: selectedCategory === cat.id, hidden: !hasItemsInCategory(cat.id) }"
          @click="selectedCategory = cat.id"
          v-show="hasItemsInCategory(cat.id)"
        >
          <div class="cat-icon"><i :class="cat.icon"></i></div>
          <span class="cat-label">{{ $t(cat.id) }}</span>
        </div>
      </div>
    </div>

    <div v-show="selectedCategory === 'all' || selectedCategory === 'antipasti'">
      <span class="txt first" v-if="antipasti.length">{{ $t('nostri_antipasti') }}</span>
      <div class="cont-antipasti cont-menu">
        <div class="card antipasto"  v-for="antipasto in antipasti" :key="antipasto.nome">
      <img v-if="antipasto.immagine" class="card-img-top dish-img" :src="antipasto.immagine" :alt="antipasto.nome" />
      <div class="card-body">
        <h5 class="card-title">{{getTranslatedName(antipasto)}}</h5>
        <div class="description-container" :class="{ expanded: antipasto.expanded }">
          <p class="card-text">{{getTranslatedDesc(antipasto)}}</p>
          <div v-if="getAllergeni(antipasto)" class="allergeni-info">
            <strong>{{ $t('allergeni') || 'Allergeni' }}:</strong> {{ getAllergeni(antipasto) }}
          </div>
        </div>
        <div class="card-meta">
          <div class="prezzo-text">{{antipasto.prezzo}} €</div>
          <button v-if="getTranslatedDesc(antipasto) || getAllergeni(antipasto)" class="btn-info-toggle" @click="toggleDetails(antipasto)" :title="$t('dettagli')">
            <i class="fas" :class="antipasto.expanded ? 'fa-chevron-up' : 'fa-info-circle'"></i>
          </button>
        </div>
        <div v-if="tok" class="mt-2">
          <input type="text" v-model="antipasto.nota" class="form-control form-control-sm" :placeholder="$t('nota', 'Nota')">
        </div>
      </div>
      <footer class="fot " v-if="tok">
        <a href="#" class="btn btn-outline-success btn-sm" @click.prevent="createOrdine(antipasto)">{{ $t('aggiungi') }}</a>
        <a href="#" v-if="antipasto.addProd.length || antipasto.removeProd.length" class="btn btn-outline-success btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" @click.prevent="canChange(antipasto.nome, antipasto.prezzo, antipasto.addProd,antipasto.removeProd,antipasto.portata,antipasto._id||antipasto.id)">{{ $t('modifica') }}</a>
      </footer>
    </div>
    </div>
    </div>

    <div v-show="selectedCategory === 'all' || selectedCategory === 'primi'">
      <div class="txt " v-if="primi.length">{{ $t('nostri_primi') }}</div>
      <div class="cont-antipasti cont-menu">
    <div class="card primi"  v-for="primo in primi" :key="primo.nome">
      <img v-if="primo.immagine" class="card-img-top dish-img" :src="primo.immagine" :alt="primo.nome" />
      <div class="card-body">
        <h5 class="card-title">{{getTranslatedName(primo)}}</h5>
        <div class="description-container" :class="{ expanded: primo.expanded }">
          <p class="card-text">{{getTranslatedDesc(primo)}}</p>
          <div v-if="getAllergeni(primo)" class="allergeni-info">
            <strong>{{ $t('allergeni') || 'Allergeni' }}:</strong> {{ getAllergeni(primo) }}
          </div>
        </div>
        <div class="card-meta">
          <div class="prezzo-text">{{primo.prezzo}} €</div>
          <button v-if="getTranslatedDesc(primo) || getAllergeni(primo)" class="btn-info-toggle" @click="toggleDetails(primo)" :title="$t('dettagli')">
            <i class="fas" :class="primo.expanded ? 'fa-chevron-up' : 'fa-info-circle'"></i>
          </button>
        </div>
        <div v-if="tok" class="mt-2">
          <input type="text" v-model="primo.nota" class="form-control form-control-sm" :placeholder="$t('nota', 'Nota')">
        </div>
      </div>
      <footer class="fot " v-if="tok">
        <a href="#" class="btn btn-outline-success btn-sm" @click.prevent="createOrdine(primo)">{{ $t('aggiungi') }}</a>
        <a href="#" v-if="primo.addProd.length || primo.removeProd.length" class="btn btn-outline-success btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" @click.prevent="canChange(primo.nome, primo.prezzo, primo.addProd,primo.removeProd,primo.portata,primo._id||primo.id)">{{ $t('modifica') }}</a>
      </footer>
    </div>
    </div>
    </div>

    <div v-show="selectedCategory === 'all' || selectedCategory === 'secondi'">
      <div class="txt" v-if="secondi.length">{{ $t('nostri_secondi') }}</div>
      <div class="cont-antipasti cont-menu">
    <div class="card secondi"  v-for="secondo in secondi" :key="secondo.nome">
      <img v-if="secondo.immagine" class="card-img-top dish-img" :src="secondo.immagine" :alt="secondo.nome" />
      <div class="card-body">
        <h5 class="card-title">{{getTranslatedName(secondo)}}</h5>
        <div class="description-container" :class="{ expanded: secondo.expanded }">
          <p class="card-text">{{getTranslatedDesc(secondo)}}</p>
          <div v-if="getAllergeni(secondo)" class="allergeni-info">
            <strong>{{ $t('allergeni') || 'Allergeni' }}:</strong> {{ getAllergeni(secondo) }}
          </div>
        </div>
        <div class="card-meta">
          <div class="prezzo-text">{{secondo.prezzo}} €</div>
          <button v-if="getTranslatedDesc(secondo) || getAllergeni(secondo)" class="btn-info-toggle" @click="toggleDetails(secondo)" :title="$t('dettagli')">
            <i class="fas" :class="secondo.expanded ? 'fa-chevron-up' : 'fa-info-circle'"></i>
          </button>
        </div>
        <div v-if="tok" class="mt-2">
          <input type="text" v-model="secondo.nota" class="form-control form-control-sm" :placeholder="$t('nota', 'Nota')">
        </div>
      </div>
     <footer class="fot " v-if="tok">
       <a href="#" class="btn btn-outline-success btn-sm" @click.prevent="createOrdine(secondo)">{{ $t('aggiungi') }}</a>
       <a href="#" v-if="secondo.addProd.length || secondo.removeProd.length" class="btn btn-outline-success btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" @click.prevent="canChange(secondo.nome, secondo.prezzo, secondo.addProd,secondo.removeProd,secondo.portata,secondo._id||secondo.id)">{{ $t('modifica') }}</a>
       </footer>
    </div>
    </div>
    </div>

    <div v-show="selectedCategory === 'all' || selectedCategory === 'contorni'">
      <div class="txt" v-if="contorni.length">{{ $t('nostri_contorni') }}</div>
      <div class="cont-antipasti cont-menu">
    <div class="card contorni"  v-for="contorno in contorni" :key="contorno.nome">
      <img v-if="contorno.immagine" class="card-img-top dish-img" :src="contorno.immagine" :alt="contorno.nome" />
      <div class="card-body">
        <h5 class="card-title">{{getTranslatedName(contorno)}}</h5>
        <div class="description-container" :class="{ expanded: contorno.expanded }">
          <p class="card-text">{{getTranslatedDesc(contorno)}}</p>
          <div v-if="getAllergeni(contorno)" class="allergeni-info">
            <strong>{{ $t('allergeni') || 'Allergeni' }}:</strong> {{ getAllergeni(contorno) }}
          </div>
        </div>
        <div class="card-meta">
          <div class="prezzo-text">{{contorno.prezzo}} €</div>
          <button v-if="getTranslatedDesc(contorno) || getAllergeni(contorno)" class="btn-info-toggle" @click="toggleDetails(contorno)" :title="$t('dettagli')">
            <i class="fas" :class="contorno.expanded ? 'fa-chevron-up' : 'fa-info-circle'"></i>
          </button>
        </div>
        <div v-if="tok" class="mt-2">
          <input type="text" v-model="contorno.nota" class="form-control form-control-sm" :placeholder="$t('nota', 'Nota')">
        </div>
      </div>
      <footer class="fot " v-if="tok">
        <a href="#" class="btn btn-outline-success btn-sm" @click.prevent="createOrdine(contorno)">{{ $t('aggiungi') }}</a>
        <a href="#" v-if="contorno.addProd.length || contorno.removeProd.length" class="btn btn-outline-success btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" @click.prevent="canChange(contorno.nome, contorno.prezzo, contorno.addProd,contorno.removeProd,contorno.portata,contorno._id||contorno.id)">{{ $t('modifica') }}</a>
      </footer>
    </div>
    </div>
    </div>

    <div v-show="selectedCategory === 'all' || selectedCategory === 'pizza'">
      <div class="txt" v-if="pizze.length">{{ $t('nostra_pizza') }}</div>
      <div class="cont-antipasti cont-menu">
    <div class="card contorni"  v-for="pizza in pizze" :key="pizza.nome">
      <img v-if="pizza.immagine" class="card-img-top dish-img" :src="pizza.immagine" :alt="pizza.nome" />
      <div class="card-body">
        <h5 class="card-title">{{getTranslatedName(pizza)}}</h5>
        <div class="description-container" :class="{ expanded: pizza.expanded }">
          <p class="card-text">{{getTranslatedDesc(pizza)}}</p>
          <div v-if="getAllergeni(pizza)" class="allergeni-info">
            <strong>{{ $t('allergeni') || 'Allergeni' }}:</strong> {{ getAllergeni(pizza) }}
          </div>
        </div>
        <div class="card-meta">
          <div class="prezzo-text">{{pizza.prezzo}} €</div>
          <button v-if="getTranslatedDesc(pizza) || getAllergeni(pizza)" class="btn-info-toggle" @click="toggleDetails(pizza)" :title="$t('dettagli')">
            <i class="fas" :class="pizza.expanded ? 'fa-chevron-up' : 'fa-info-circle'"></i>
          </button>
        </div>
        <div v-if="tok" class="mt-2">
          <input type="text" v-model="pizza.nota" class="form-control form-control-sm" :placeholder="$t('nota', 'Nota')">
        </div>
      </div>
      <footer class="fot " v-if="tok">
        <a href="#" class="btn btn-outline-success btn-sm" @click.prevent="createOrdine(pizza)">{{ $t('aggiungi') }}</a>
        <a href="#" v-if="pizza.addProd.length || pizza.removeProd.length" class="btn btn-outline-success btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" @click.prevent="canChange(pizza.nome, pizza.prezzo, pizza.addProd,pizza.removeProd,pizza.portata,pizza._id||pizza.id)">{{ $t('modifica') }}</a>
      </footer>
    </div>
    </div>
    </div>
        <!-- Nuove Categorie -->


      <div v-show="selectedCategory === 'all' || selectedCategory === 'focaccia'">
      <div class="txt" v-if="focacce.length">{{ $t('nostra_focaccia') }}</div>
      <div class="cont-antipasti cont-menu">
        <div class="card focaccia" v-for="focaccia in focacce" :key="focaccia.nome">
          <img v-if="focaccia.immagine" class="card-img-top dish-img" :src="focaccia.immagine" :alt="focaccia.nome" />
          <div class="card-body">
            <h5 class="card-title">{{getTranslatedName(focaccia)}}</h5>
            <div class="description-container" :class="{ expanded: focaccia.expanded }">
              <p class="card-text">{{getTranslatedDesc(focaccia)}}</p>
              <div v-if="getAllergeni(focaccia)" class="allergeni-info">
                <strong>{{ $t('allergeni') || 'Allergeni' }}:</strong> {{ getAllergeni(focaccia) }}
              </div>
            </div>
            <div class="card-meta">
              <div class="prezzo-text">{{focaccia.prezzo}} €</div>
              <button v-if="getTranslatedDesc(focaccia) || getAllergeni(focaccia)" class="btn-info-toggle" @click="toggleDetails(focaccia)" :title="$t('dettagli')">
                <i class="fas" :class="focaccia.expanded ? 'fa-chevron-up' : 'fa-info-circle'"></i>
              </button>
            </div>
            <div v-if="tok" class="mt-2">
              <input type="text" v-model="focaccia.nota" class="form-control form-control-sm" :placeholder="$t('nota', 'Nota')">
            </div>
          </div>
          <footer class="fot " v-if="tok">
            <a href="#" class="btn btn-outline-success btn-sm" @click.prevent="createOrdine(focaccia)">{{ $t('aggiungi') }}</a>
            <a href="#" v-if="focaccia.addProd.length || focaccia.removeProd.length" class="btn btn-outline-success btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" @click.prevent="canChange(focaccia.nome, focaccia.prezzo, focaccia.addProd,focaccia.removeProd,focaccia.portata,focaccia._id||focaccia.id)">{{ $t('modifica') }}</a>
          </footer>
        </div>
      </div>
    </div>
    <div v-show="selectedCategory === 'all' || selectedCategory === 'trancio'">
      <div class="txt" v-if="tranci.length">{{ $t('nostro_trancio') }}</div>
      <div class="cont-antipasti cont-menu">
        <div class="card trancio" v-for="trancio in tranci" :key="trancio.nome">
          <img v-if="trancio.immagine" class="card-img-top dish-img" :src="trancio.immagine" :alt="trancio.nome" />
          <div class="card-body">
            <h5 class="card-title">{{getTranslatedName(trancio)}}</h5>
            <div class="description-container" :class="{ expanded: trancio.expanded }">
              <p class="card-text">{{getTranslatedDesc(trancio)}}</p>
              <div v-if="getAllergeni(trancio)" class="allergeni-info">
                <strong>{{ $t('allergeni') || 'Allergeni' }}:</strong> {{ getAllergeni(trancio) }}
              </div>
            </div>
            <div class="card-meta">
              <div class="prezzo-text">{{trancio.prezzo}} €</div>
              <button v-if="getTranslatedDesc(trancio) || getAllergeni(trancio)" class="btn-info-toggle" @click="toggleDetails(trancio)" :title="$t('dettagli')">
                <i class="fas" :class="trancio.expanded ? 'fa-chevron-up' : 'fa-info-circle'"></i>
              </button>
            </div>
            <div v-if="tok" class="mt-2">
              <input type="text" v-model="trancio.nota" class="form-control form-control-sm" :placeholder="$t('nota', 'Nota')">
            </div>
          </div>
          <footer class="fot " v-if="tok">
            <a href="#" class="btn btn-outline-success btn-sm" @click.prevent="createOrdine(trancio)">{{ $t('aggiungi') }}</a>
            <a href="#" v-if="trancio.addProd.length || trancio.removeProd.length" class="btn btn-outline-success btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" @click.prevent="canChange(trancio.nome, trancio.prezzo, trancio.addProd,trancio.removeProd,trancio.portata,trancio._id||trancio.id)">{{ $t('modifica') }}</a>
          </footer>
        </div>
      </div>
    </div>


    <div v-show="selectedCategory === 'all' || selectedCategory === 'teglia'">
      <div class="txt" v-if="teglie.length">{{ $t('nostra_teglia') }}</div>
      <div class="cont-antipasti cont-menu">
        <div class="card teglia" v-for="teglia in teglie" :key="teglia.nome">
          <img v-if="teglia.immagine" class="card-img-top dish-img" :src="teglia.immagine" :alt="teglia.nome" />
          <div class="card-body">
            <h5 class="card-title">{{getTranslatedName(teglia)}}</h5>
            <div class="description-container" :class="{ expanded: teglia.expanded }">
              <p class="card-text">{{getTranslatedDesc(teglia)}}</p>
              <div v-if="getAllergeni(teglia)" class="allergeni-info">
                <strong>{{ $t('allergeni') || 'Allergeni' }}:</strong> {{ getAllergeni(teglia) }}
              </div>
            </div>
            <div class="card-meta">
              <div class="prezzo-text">{{teglia.prezzo}} €</div>
              <button v-if="getTranslatedDesc(teglia) || getAllergeni(teglia)" class="btn-info-toggle" @click="toggleDetails(teglia)" :title="$t('dettagli')">
                <i class="fas" :class="teglia.expanded ? 'fa-chevron-up' : 'fa-info-circle'"></i>
              </button>
            </div>
            <div v-if="tok" class="mt-2">
              <input type="text" v-model="teglia.nota" class="form-control form-control-sm" :placeholder="$t('nota', 'Nota')">
            </div>
          </div>
          <footer class="fot " v-if="tok">
            <a href="#" class="btn btn-outline-success btn-sm" @click.prevent="createOrdine(teglia)">{{ $t('aggiungi') }}</a>
            <a href="#" v-if="teglia.addProd.length || teglia.removeProd.length" class="btn btn-outline-success btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" @click.prevent="canChange(teglia.nome, teglia.prezzo, teglia.addProd,teglia.removeProd,teglia.portata,teglia._id||teglia.id)">{{ $t('modifica') }}</a>
          </footer>
        </div>
      </div>
    </div>
        <div v-show="selectedCategory === 'all' || selectedCategory === 'combo'">
      <div class="txt" v-if="combos.length">{{ $t('nostra_combo') }}</div>
      <div class="cont-antipasti cont-menu">
        <div class="card combo" v-for="combo in combos" :key="combo.nome">
          <img v-if="combo.immagine" class="card-img-top dish-img" :src="combo.immagine" :alt="combo.nome" />
          <div class="card-body">
            <h5 class="card-title">{{getTranslatedName(combo)}}</h5>
            <div class="description-container" :class="{ expanded: combo.expanded }">
              <p class="card-text">{{getTranslatedDesc(combo)}}</p>
              <div v-if="getAllergeni(combo)" class="allergeni-info">
                <strong>{{ $t('allergeni') || 'Allergeni' }}:</strong> {{ getAllergeni(combo) }}
              </div>
            </div>
            <div class="card-meta">
              <div class="prezzo-text">{{combo.prezzo}} €</div>
              <button v-if="getTranslatedDesc(combo) || getAllergeni(combo)" class="btn-info-toggle" @click="toggleDetails(combo)" :title="$t('dettagli')">
                <i class="fas" :class="combo.expanded ? 'fa-chevron-up' : 'fa-info-circle'"></i>
              </button>
            </div>
            <div v-if="tok" class="mt-2">
              <input type="text" v-model="combo.nota" class="form-control form-control-sm" :placeholder="$t('nota', 'Nota')">
            </div>
          </div>
          <footer class="fot " v-if="tok">
            <a href="#" class="btn btn-outline-success btn-sm" @click.prevent="createOrdine(combo)">{{ $t('aggiungi') }}</a>
            <a href="#" v-if="combo.addProd.length || combo.removeProd.length" class="btn btn-outline-success btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" @click.prevent="canChange(combo.nome, combo.prezzo, combo.addProd,combo.removeProd,combo.portata,combo._id||combo.id)">{{ $t('modifica') }}</a>
          </footer>
        </div>
      </div>
    </div>

    <div v-show="selectedCategory === 'all' || selectedCategory === 'insalate'">
      <div class="txt" v-if="insalate.length">{{ $t('nostre_insalate') }}</div>
      <div class="cont-antipasti cont-menu">
        <div class="card insalate" v-for="insalata in insalate" :key="insalata.nome">
          <img v-if="insalata.immagine" class="card-img-top dish-img" :src="insalata.immagine" :alt="insalata.nome" />
          <div class="card-body">
            <h5 class="card-title">{{getTranslatedName(insalata)}}</h5>
            <div class="description-container" :class="{ expanded: insalata.expanded }">
              <p class="card-text">{{getTranslatedDesc(insalata)}}</p>
              <div v-if="getAllergeni(insalata)" class="allergeni-info">
                <strong>{{ $t('allergeni') || 'Allergeni' }}:</strong> {{ getAllergeni(insalata) }}
              </div>
            </div>
            <div class="card-meta">
              <div class="prezzo-text">{{insalata.prezzo}} €</div>
              <button v-if="getTranslatedDesc(insalata) || getAllergeni(insalata)" class="btn-info-toggle" @click="toggleDetails(insalata)" :title="$t('dettagli')">
                <i class="fas" :class="insalata.expanded ? 'fa-chevron-up' : 'fa-info-circle'"></i>
              </button>
            </div>
            <div v-if="tok" class="mt-2">
              <input type="text" v-model="insalata.nota" class="form-control form-control-sm" :placeholder="$t('nota', 'Nota')">
            </div>
          </div>
          <footer class="fot " v-if="tok">
            <a href="#" class="btn btn-outline-success btn-sm" @click.prevent="createOrdine(insalata)">{{ $t('aggiungi') }}</a>
            <a href="#" v-if="insalata.addProd.length || insalata.removeProd.length" class="btn btn-outline-success btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" @click.prevent="canChange(insalata.nome, insalata.prezzo, insalata.addProd,insalata.removeProd,insalata.portata,insalata._id||insalata.id)">{{ $t('modifica') }}</a>
          </footer>
        </div>
      </div>
    </div>


    <div v-show="selectedCategory === 'all' || selectedCategory === 'sushi'">
      <div class="txt" v-if="sushi.length">{{ $t('nostro_sushi') }}</div>
      <div class="cont-antipasti cont-menu">
    <div class="card contorni"  v-for="sus in sushi" :key="sus.nome">
      <img v-if="sus.immagine" class="card-img-top dish-img" :src="sus.immagine" :alt="sus.nome" />
      <div class="card-body">
        <h5 class="card-title">{{getTranslatedName(sus)}}</h5>
        <div class="description-container" :class="{ expanded: sus.expanded }">
          <p class="card-text">{{getTranslatedDesc(sus)}}</p>
          <div v-if="getAllergeni(sus)" class="allergeni-info">
            <strong>{{ $t('allergeni') || 'Allergeni' }}:</strong> {{ getAllergeni(sus) }}
          </div>
        </div>
        <div class="card-meta">
          <div class="prezzo-text">{{sus.prezzo}} €</div>
          <button v-if="getTranslatedDesc(sus) || getAllergeni(sus)" class="btn-info-toggle" @click="toggleDetails(sus)" :title="$t('dettagli')">
            <i class="fas" :class="sus.expanded ? 'fa-chevron-up' : 'fa-info-circle'"></i>
          </button>
        </div>
        <div v-if="tok" class="mt-2">
          <input type="text" v-model="sus.nota" class="form-control form-control-sm" :placeholder="$t('nota', 'Nota')">
        </div>
      </div>
      <footer class="fot " v-if="tok">
        <a href="#" class="btn btn-outline-success btn-sm" @click.prevent="createOrdine(sus)">{{ $t('aggiungi') }}</a>
        <a href="#" v-if="sus.addProd.length || sus.removeProd.length" class="btn btn-outline-success btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" @click.prevent="canChange(sus.nome, sus.prezzo, sus.addProd,sus.removeProd,sus.portata,sus._id||sus.id)">{{ $t('modifica') }}</a>
      </footer>
    </div>
    </div>
    </div>

    <div v-show="selectedCategory === 'all' || selectedCategory === 'dolci'">
      <div class="txt" v-if="dolci.length">{{ $t('nostri_dolci') }}</div>
      <div class="cont-antipasti cont-menu">
    <div class="card dolci"  v-for="dolce in dolci" :key="dolce.nome">
      <img v-if="dolce.immagine" class="card-img-top dish-img" :src="dolce.immagine" :alt="dolce.nome" />
      <div class="card-body">
        <h5 class="card-title">{{getTranslatedName(dolce)}}</h5>
        <div class="description-container" :class="{ expanded: dolce.expanded }">
          <p class="card-text">{{getTranslatedDesc(dolce)}}</p>
          <div v-if="getAllergeni(dolce)" class="allergeni-info">
            <strong>{{ $t('allergeni') || 'Allergeni' }}:</strong> {{ getAllergeni(dolce) }}
          </div>
        </div>
        <div class="card-meta">
          <div class="prezzo-text">{{dolce.prezzo}} €</div>
          <button v-if="getTranslatedDesc(dolce) || getAllergeni(dolce)" class="btn-info-toggle" @click="toggleDetails(dolce)" :title="$t('dettagli')">
            <i class="fas" :class="dolce.expanded ? 'fa-chevron-up' : 'fa-info-circle'"></i>
          </button>
        </div>
        <div v-if="tok" class="mt-2">
          <input type="text" v-model="dolce.nota" class="form-control form-control-sm" :placeholder="$t('nota', 'Nota')">
        </div>
      </div>
      <footer class="fot " v-if="tok">
        <a href="#" class="btn btn-outline-success btn-sm" @click.prevent="createOrdine(dolce)">{{ $t('aggiungi') }}</a>
        <a href="#" v-if="dolce.addProd.length || dolce.removeProd.length" class="btn btn-outline-success btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" @click.prevent="canChange(dolce.nome, dolce.prezzo, dolce.addProd,dolce.removeProd,dolce.portata,dolce._id||dolce.id)">{{ $t('modifica') }}</a>
      </footer>
    </div>
    </div>
    </div>

    <div v-show="selectedCategory === 'all' || selectedCategory === 'poke'">
      <div class="txt" v-if="poke.length">{{ $t('nostro_poke') }}</div>
      <div class="cont-antipasti cont-menu">
    <div class="card poke"  v-for="pokeItem in poke" :key="pokeItem.nome">
      <img v-if="pokeItem.immagine" class="card-img-top dish-img" :src="pokeItem.immagine" :alt="pokeItem.nome" />
      <div class="card-body">
        <h5 class="card-title">{{getTranslatedName(pokeItem)}}</h5>
        <div class="description-container" :class="{ expanded: pokeItem.expanded }">
          <p class="card-text">{{getTranslatedDesc(pokeItem)}}</p>
          <div v-if="getAllergeni(pokeItem)" class="allergeni-info">
            <strong>{{ $t('allergeni') || 'Allergeni' }}:</strong> {{ getAllergeni(pokeItem) }}
          </div>
        </div>
        <div class="card-meta">
          <div class="prezzo-text">{{pokeItem.prezzo}} €</div>
          <button v-if="getTranslatedDesc(pokeItem) || getAllergeni(pokeItem)" class="btn-info-toggle" @click="toggleDetails(pokeItem)" :title="$t('dettagli')">
            <i class="fas" :class="pokeItem.expanded ? 'fa-chevron-up' : 'fa-info-circle'"></i>
          </button>
        </div>
        <div v-if="tok" class="mt-2">
          <input type="text" v-model="pokeItem.nota" class="form-control form-control-sm" :placeholder="$t('nota', 'Nota')">
        </div>
      </div>
      <footer class="fot " v-if="tok">
        <a href="#" class="btn btn-outline-success btn-sm" @click.prevent="createOrdine(pokeItem)">{{ $t('aggiungi') }}</a>
        <a href="#" v-if="pokeItem.addProd.length || pokeItem.removeProd.length" class="btn btn-outline-success btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" @click.prevent="canChange(pokeItem.nome, pokeItem.prezzo, pokeItem.addProd,pokeItem.removeProd,pokeItem.portata,pokeItem._id||pokeItem.id)">{{ $t('modifica') }}</a>
      </footer>
    </div>
    </div>
    </div>

    <div v-show="selectedCategory === 'all' || selectedCategory === 'frutta'">
      <div class="txt" v-if="frutta.length">{{ $t('nostra_frutta') }}</div>
      <div class="cont-antipasti cont-menu">
    <div class="card frutta"  v-for="frutto in frutta" :key="frutto.nome">
      <img v-if="frutto.immagine" class="card-img-top dish-img" :src="frutto.immagine" :alt="frutto.nome" />
      <div class="card-body">
        <h5 class="card-title">{{getTranslatedName(frutto)}}</h5>
        <div class="description-container" :class="{ expanded: frutto.expanded }">
          <p class="card-text">{{getTranslatedDesc(frutto)}}</p>
          <div v-if="getAllergeni(frutto)" class="allergeni-info">
            <strong>{{ $t('allergeni') || 'Allergeni' }}:</strong> {{ getAllergeni(frutto) }}
          </div>
        </div>
        <div class="card-meta">
          <div class="prezzo-text">{{frutto.prezzo}} €</div>
          <button v-if="getTranslatedDesc(frutto) || getAllergeni(frutto)" class="btn-info-toggle" @click="toggleDetails(frutto)" :title="$t('dettagli')">
            <i class="fas" :class="frutto.expanded ? 'fa-chevron-up' : 'fa-info-circle'"></i>
          </button>
        </div>
        <div v-if="tok" class="mt-2">
          <input type="text" v-model="frutto.nota" class="form-control form-control-sm" :placeholder="$t('nota', 'Nota')">
        </div>
      </div>
      <footer class="fot " v-if="tok">
        <a href="#" class="btn btn-outline-success btn-sm" @click.prevent="createOrdine(frutto)">{{ $t('aggiungi') }}</a>
        <a href="#" v-if="frutto.addProd.length || frutto.removeProd.length" class="btn btn-outline-success btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" @click.prevent="canChange(frutto.nome, frutto.prezzo, frutto.addProd,frutto.removeProd,frutto.portata,frutto._id||frutto.id)">{{ $t('modifica') }}</a>
      </footer>
    </div>
    </div>
    </div>

    <div v-show="selectedCategory === 'all' || selectedCategory === 'amari'">
      <div class="txt" v-if="amari.length">{{ $t('nostri_amari') }}</div>
      <div class="cont-antipasti cont-menu">
    <div class="card amari"  v-for="amaro in amari" :key="amaro.nome">
      <img v-if="amaro.immagine" class="card-img-top dish-img" :src="amaro.immagine" :alt="amaro.nome" />
      <div class="card-body">
        <h5 class="card-title">{{getTranslatedName(amaro)}}</h5>
        <div class="description-container" :class="{ expanded: amaro.expanded }">
          <p class="card-text">{{getTranslatedDesc(amaro)}}</p>
          <div v-if="getAllergeni(amaro)" class="allergeni-info">
            <strong>{{ $t('allergeni') || 'Allergeni' }}:</strong> {{ getAllergeni(amaro) }}
          </div>
        </div>
        <div class="card-meta">
          <div class="prezzo-text">{{amaro.prezzo}} €</div>
          <button v-if="getTranslatedDesc(amaro) || getAllergeni(amaro)" class="btn-info-toggle" @click="toggleDetails(amaro)" :title="$t('dettagli')">
            <i class="fas" :class="amaro.expanded ? 'fa-chevron-up' : 'fa-info-circle'"></i>
          </button>
        </div>
        <div v-if="tok" class="mt-2">
          <input type="text" v-model="amaro.nota" class="form-control form-control-sm" :placeholder="$t('nota', 'Nota')">
        </div>
      </div>
      <footer class="fot " v-if="tok">
        <a href="#" class="btn btn-outline-success btn-sm" @click.prevent="createOrdine(amaro)">{{ $t('aggiungi') }}</a>
        <a href="#" v-if="amaro.addProd.length || amaro.removeProd.length" class="btn btn-outline-success btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" @click.prevent="canChange(amaro.nome, amaro.prezzo, amaro.addProd,amaro.removeProd,amaro.portata,amaro._id||amaro.id)">{{ $t('modifica') }}</a>
      </footer>
    </div>
    </div>
    </div>

    <div v-show="selectedCategory === 'all' || selectedCategory === 'bevande'">
      <div class="txt" v-if="bevande.length">{{ $t('nostre_bevande') }}</div>
      <div class="cont-antipasti cont-menu">
    <div class="card bevande"  v-for="bevanda in bevande" :key="bevanda.nome">
      <img v-if="bevanda.immagine" class="card-img-top dish-img" :src="bevanda.immagine" :alt="bevanda.nome" />
      <div class="card-body">
        <h5 class="card-title">{{getTranslatedName(bevanda)}}</h5>
        <div class="description-container" :class="{ expanded: bevanda.expanded }">
          <p class="card-text">{{getTranslatedDesc(bevanda)}}</p>
          <div v-if="getAllergeni(bevanda)" class="allergeni-info">
            <strong>{{ $t('allergeni') || 'Allergeni' }}:</strong> {{ getAllergeni(bevanda) }}
          </div>
        </div>
        <div class="card-meta">
          <div class="prezzo-text">{{bevanda.prezzo}} €</div>
          <button v-if="getTranslatedDesc(bevanda) || getAllergeni(bevanda)" class="btn-info-toggle" @click="toggleDetails(bevanda)" :title="$t('dettagli')">
            <i class="fas" :class="bevanda.expanded ? 'fa-chevron-up' : 'fa-info-circle'"></i>
          </button>
        </div>
        <div v-if="tok" class="mt-2">
          <input type="text" v-model="bevanda.nota" class="form-control form-control-sm" :placeholder="$t('nota', 'Nota')">
        </div>
      </div>
      <footer class="fot " v-if="tok">
        <a href="#" class="btn btn-outline-success btn-sm" @click.prevent="createOrdine(bevanda)">{{ $t('aggiungi') }}</a>
        <a href="#" v-if="bevanda.addProd.length || bevanda.removeProd.length" class="btn btn-outline-success btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" @click.prevent="canChange(bevanda.nome, bevanda.prezzo, bevanda.addProd,bevanda.removeProd,bevanda.portata,bevanda._id||bevanda.id)">{{ $t('modifica') }}</a>
      </footer>
    </div>
    </div>
    </div>
    <div v-show="selectedCategory === 'all' || selectedCategory === 'calice'">
      <div class="txt" v-if="calice.length">{{ $t('nostro_calice') }}</div>
      <div class="cont-antipasti cont-menu">
      <div class="card calice"  v-for="caliceItem in calice" :key="caliceItem.nome">
        <img v-if="caliceItem.immagine" class="card-img-top dish-img" :src="caliceItem.immagine" :alt="caliceItem.nome" />
        <div class="card-body">
          <h5 class="card-title">{{getTranslatedName(caliceItem)}}</h5>
          <div class="description-container" :class="{ expanded: caliceItem.expanded }">
            <p class="card-text">{{getTranslatedDesc(caliceItem)}}</p>
            <div v-if="getAllergeni(caliceItem)" class="allergeni-info">
              <strong>{{ $t('allergeni') || 'Allergeni' }}:</strong> {{ getAllergeni(caliceItem) }}
            </div>
          </div>
          <div class="card-meta">
            <div class="prezzo-text">{{caliceItem.prezzo}} €</div>
            <button v-if="getTranslatedDesc(caliceItem) || getAllergeni(caliceItem)" class="btn-info-toggle" @click="toggleDetails(caliceItem)" :title="$t('dettagli')">
              <i class="fas" :class="caliceItem.expanded ? 'fa-chevron-up' : 'fa-info-circle'"></i>
            </button>
          </div>
          <div v-if="tok" class="mt-2">
            <input type="text" v-model="caliceItem.nota" class="form-control form-control-sm" :placeholder="$t('nota', 'Nota')">
          </div>
        </div>
        <footer class="fot " v-if="tok">
          <a href="#" class="btn btn-outline-success btn-sm" @click.prevent="createOrdine(caliceItem)">{{ $t('aggiungi') }}</a>
          <a href="#" v-if="caliceItem.addProd.length || caliceItem.removeProd.length" class="btn btn-outline-success btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" @click.prevent="canChange(caliceItem.nome, caliceItem.prezzo, caliceItem.addProd,caliceItem.removeProd,caliceItem.portata,caliceItem._id||caliceItem.id)">{{ $t('modifica') }}</a>
        </footer>
      </div>
      </div>
    </div>

    <div class="error-message" v-if="errorMessage">{{ errorMessage }}</div>
    </div>
    </div>
</template>


<script>
// @ is an alias to /src
import { store } from '../store/store.js'
import Sticky from 'vue-sticky-directive'
import moment from 'moment'
import { io } from "socket.io-client"
  const socket = io(process.env.VUE_APP_SOCKET_URL, { autoConnect: false });
export default {
  name: 'Menu',
  directives: {Sticky},
  data: function(){

      return {
        piatti:[],
        antipasti:[],
        primi:[],
        secondi:[],
        contorni:[],
        pizze:[],
        sushi:[],
        dolci:[],
        frutta:[],
        caffe:[],
        amari:[],
        bevande:[],
        calice:[],
        poke:[],
        tranci:[],
        focacce:[],
        teglie:[],
        combos:[],
        insalate:[],
        orderCard:['primi','secondi','poke','contorni','pizza','focaccia','trancio','teglia','combo','insalate','dolci','frutta','amari','caffe','bevande','calice'],
        displayOrdine:false,
        ordine:[],
        checked:'1° portata',
        position:false,
        date: new Date(),
        tm:'',
        add:[],
        remove:[],
        aggiunte:[],
        senza:[],
        selectedNome: null,
        selectedPrezzo: null,
        selectedPortata: null,
        selectedId: null,
        notaModal: '',
        selectedCategory: 'all',
        categories: [
          { id: 'antipasti', label: 'nostri_antipasti', icon: 'fas fa-concierge-bell' },
          { id: 'primi', label: 'nostri_primi', icon: 'fas fa-utensils' },
          { id: 'secondi', label: 'nostri_secondi', icon: 'fas fa-drumstick-bite' },
          { id: 'poke', label: 'nostro_poke', icon: 'fas fa-concierge-bell' },
          { id: 'contorni', label: 'nostri_contorni', icon: 'fas fa-leaf' },
          { id: 'pizza', label: 'nostra_pizza', icon: 'fas fa-pizza-slice' },
          { id: 'focaccia', label: 'nostra_focaccia', icon: 'fas fa-bread-slice' },
          { id: 'trancio', label: 'nostro_trancio', icon: 'fas fa-pizza-slice' },
          { id: 'teglia', label: 'nostra_teglia', icon: 'fas fa-layer-group' },
          { id: 'combo', label: 'nostra_combo', icon: 'fas fa-plus-circle' },
          { id: 'insalate', label: 'nostre_insalate', icon: 'fas fa-leaf' },
          { id: 'sushi', label: 'nostro_sushi', icon: 'fas fa-fish' },
          { id: 'dolci', label: 'nostri_dolci', icon: 'fas fa-ice-cream' },
          { id: 'amari', label: 'nostri_amari', icon: 'fas fa-glass-martini-alt' },
          { id: 'bevande', label: 'nostre_bevande', icon: 'fas fa-wine-bottle' },
          { id: 'calice', label: 'nostro_calice', icon: 'fas fa-wine-glass' },
        ],
        tok:localStorage.getItem('token')?localStorage.getItem('token'):'',
        errorMessage: '',
        deliveryPlatforms: [],
        selectedDelivery: null,
        showSummaryModal: false,
        store
      }
  },
  methods: {
    fetchDeliveryPlatforms() {
      this.axios.get(this.store.path + 'impostazioni/69c90e57851daafaf559b837', {
        headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
      }).then(res => {
        if (res.data && Array.isArray(res.data.delivery)) {
          this.deliveryPlatforms = res.data.delivery;
        }
      }).catch(err => {
        console.error("Errore nel recupero piattaforme delivery:", err);
      });
    },
    selectDelivery(platformName) {
      if (this.selectedDelivery === platformName) {
        this.selectedDelivery = null;
      } else {
        this.selectedDelivery = platformName;
      }
    },
    socketConnect () {
      socket.connect();
    },
    socketOrdine (sala,tavolo) {
        socket.emit('nuovoOrdine',{sala,tavolo},()=>{

        });
    },
    displayMenu() {
        this.axios.post(this.store.path+'displayMenu').then((response) => {
            console.log(response.data.messaggio)
            if(response.data.messaggio){
                console.log('Le Sale sono state caricate correttamente')
            }else{console.log('Non è stato possibile caricare le sale')}
            response.data.messaggio.forEach(element => {
                  element.expanded = false;
                  element.nota = '';
                  this.piatti.push(element);
            });
            this.createOrderCard();
        })
    },
    createOrderCard (){
      this.piatti.forEach(element =>{
        console.log(element.portata)
        if(element.portata == 'antipasti') {this.antipasti.push(element)}
        if(element.portata == 'primi') {this.primi.push(element)}
        if(element.portata == 'secondi') {this.secondi.push(element)}
        if(element.portata == 'contorni') {this.contorni.push(element)}
        if(element.portata == 'pizza') {this.pizze.push(element)}
        if(element.portata == 'focaccia') {this.focacce.push(element)}
        if(element.portata == 'trancio') {this.tranci.push(element)}
        if(element.portata == 'teglia') {this.teglie.push(element)}
        if(element.portata == 'combo') {this.combos.push(element)}
        if(element.portata == 'insalate') {this.insalate.push(element)}
        if(element.portata == 'sushi') {this.sushi.push(element)}
        if(element.portata == 'dolci') {this.dolci.push(element)}
        if(element.portata == 'caffe') {this.caffe.push(element)}
        if(element.portata == 'frutta') {this.frutta.push(element)}
        if(element.portata == 'amari') {this.amari.push(element)}
        if(element.portata == 'calice') {this.calice.push(element)}
        if(element.portata == 'poke') {this.poke.push(element)}
        if(element.portata == 'bevande') {this.bevande.push(element)}
      })

    },
    canChange (nome, prezzo, add, remove, portata, id) {
      this.selectedNome = nome;
      this.selectedPrezzo = prezzo;
      this.selectedPortata = portata;
      this.selectedId = id;
      this.add= add;
      this.remove=remove;
      this.aggiunte=[];
      this.senza=[];
      this.notaModal = '';
    },
    createOrdine (item) {
      this.ordine.push({ 
        quantita: 1, 
        piatto: item.nome, 
        piattoId: item._id || item.id, 
        prezzo: item.prezzo, 
        portata: item.portata, 
        ordine: this.checked, 
        aggiunta: [], 
        senza: [],
        nota: item.nota || ''
      })
      item.nota = '';
    },
    getItemLabel(item) {
      if (item === null || item === undefined) return '';
      if (typeof item === 'object') {
        return item.descrizione || item.nome || item.descrizio || item.prodottoId || JSON.stringify(item);
      }
      return item;
    },
    getSortedItems(list) {
      if (!Array.isArray(list)) return [];
      return [...list].sort((a, b) => {
        const labelA = String(this.getItemLabel(a) || '').toLowerCase();
        const labelB = String(this.getItemLabel(b) || '').toLowerCase();
        return labelA.localeCompare(labelB, undefined, { sensitivity: 'base' });
      });
    },
    getOptionKey(item, idx) {
      if (item === null || item === undefined) return idx;
      if (typeof item === 'object') {
        return item._id || item.prodottoId || item.code || item.nome || item.descrizione || idx;
      }
      return String(item) + '-' + idx;
    },
    getTranslatedName(item) {
      if (!item) return '';
      const locale = this.$i18n.locale;
      if (locale === 'en') return item.nomeEn || item.nome;
      if (locale === 'es') return item.nomeEs || item.nome;
      return item.nome;
    },
    getTranslatedDesc(item) {
      if (!item) return '';
      const locale = this.$i18n.locale;
      if (locale === 'en') return item.descrizioneEn || item.descrizione;
      if (locale === 'es') return item.descrizioneEs || item.descrizione;
      return item.descrizione;
    },
    createOrdineFromModal() {
      if (this.selectedNome) {
        this.ordine.push({
          quantita: 1, 
          piatto: this.selectedNome, 
          piattoId: this.selectedId,
          prezzo: this.selectedPrezzo, 
          portata: this.selectedPortata,
          ordine: this.checked, 
          aggiunta: [...this.aggiunte], 
          senza: [...this.senza],
          nota: this.notaModal
        });
        this.aggiunte=[];
        this.senza=[];
        this.notaModal = '';
        this.selectedNome = null;
        this.selectedPrezzo = null;
      }
    },
    deleteP(ind) {
      this.ordine.splice(ind,1)
    },
    openOrderSummary() {
      if (!this.ordine || this.ordine.length === 0) {
        this.errorMessage = this.$t('nessun_piatto_ordine', 'Nessun piatto presente nell\'ordine!');
        setTimeout(() => {
          this.errorMessage = '';
        }, 3000);
        return;
      }
      this.showSummaryModal = true;
    },
    closeOrderSummary() {
      this.showSummaryModal = false;
    },
    confermaEInviaOrdine() {
      this.showSummaryModal = false;
      this.inviaOrdine();
    },
    incrementQuantity(index) {
      if (this.ordine[index]) {
        this.ordine[index].quantita = (this.ordine[index].quantita || 1) + 1;
      }
    },
    decrementQuantity(index) {
      if (this.ordine[index]) {
        if (this.ordine[index].quantita > 1) {
          this.ordine[index].quantita -= 1;
        } else {
          this.deleteP(index);
        }
      }
    },
    getOrderTotal() {
      if (!this.ordine) return 0;
      return this.ordine.reduce((acc, item) => acc + (item.prezzo * item.quantita), 0);
    },
    getOrderItemsCount() {
      if (!this.ordine) return 0;
      return this.ordine.reduce((acc, item) => acc + (item.quantita || 1), 0);
    },
    getTableInfo() {
      let sala = '';
      let tavolo = '';
      let coperti = 0;
      let stored = localStorage.getItem('ordineAttuale');
      if (stored) {
        try {
          let parsed = JSON.parse(stored);
          sala = parsed.sala || '';
          tavolo = parsed.tavolo || '';
          coperti = parsed.coperti || 0;
        } catch (e) {
          console.error("Errore parse ordineAttuale:", e);
        }
      } else if (this.position) {
        var position = (this.position || "").split('-');
        if (position.length >= 2) {
          sala = position[0].slice(2, position[0].length);
          tavolo = position[1].slice(0, position[1].length - 1);
        }
      }
      return { sala, tavolo, coperti };
    },
    toggleDetails(dish) {
      dish.expanded = !dish.expanded;
    },
  inviaOrdine() {
    this.tm = moment(this.date).unix();
    let stored = localStorage.getItem('ordineAttuale');
    let sala = '';
    let tavolo = '';
    let coperti = 0;
    if (stored) {
      let parsed = JSON.parse(stored);
      sala = parsed.sala;
      tavolo = parsed.tavolo;
      coperti = parsed.coperti || 0;
    } else {
      var position = (this.position || "").split('-');
      if (position.length >= 2) {
        sala = position[0].slice(2, position[0].length);
        tavolo = position[1].slice(0, position[1].length -1);
      }
    }

    this.axios.post(this.store.path+ `creaOrdine`,{
      coperti: coperti,
      sala: sala,
      tavolo: tavolo,
      ordinazione: this.ordine,
      delivery: this.selectedDelivery,
      tm: this.tm,
      headers:{ authorization: `Bearer  ${JSON.parse(localStorage.token)}`}
    }).then((response) => {
      if(response.data){
        console.log('Ordinazione Creata con Successo');
        this.ordine=[];
        this.selectedDelivery = null;
        this.socketOrdine(sala, tavolo);
        let stored = localStorage.getItem('ordineAttuale');
        if (stored) {
          let parsed = JSON.parse(stored);
          if (parsed.sala) {
            this.$router.push({
              name: "VisualizzaSala",
              params: {
                nome: parsed.sala,
                numero: parsed.numero,
                sale: parsed.sale,
                numeroSale: parsed.numeroSale
              }
            });
            localStorage.removeItem('ordineAttuale');
            return;
          }
        }
        this.$router.push({ name: "Sala" });
      }else{
        console.log('Non è stato possibile Aggiornare il menu')
      }
    }).catch((err) => {
      console.error("Errore invio ordine:", err);
      this.errorMessage = err.response && err.response.data && err.response.data.messaggio 
        ? err.response.data.messaggio 
        : (err.message || 'Errore durante l\'invio dell\'ordine');
      
      setTimeout(() => {
        this.errorMessage = '';
      }, 5000);
    });
  },
  hasItemsInCategory(catId) {
    if (catId === 'antipasti') return this.antipasti.length > 0;
    if (catId === 'primi') return this.primi.length > 0;
    if (catId === 'secondi') return this.secondi.length > 0;
    if (catId === 'contorni') return this.contorni.length > 0;
    if (catId === 'pizza') return this.pizze.length > 0;
    if (catId === 'sushi') return this.sushi.length > 0;
    if (catId === 'dolci') return this.dolci.length > 0;
    if (catId === 'amari') return this.amari.length > 0;
    if (catId === 'bevande') return this.bevande.length > 0;
    if (catId === 'calice') return this.calice.length > 0;
    if (catId === 'poke') return this.poke.length > 0;
    if (catId === 'trancio') return this.tranci.length > 0;
    if (catId === 'focaccia') return this.focacce.length > 0;
    if (catId === 'teglia') return this.teglie.length > 0;
    if (catId === 'combo') return this.combos.length > 0;
    if (catId === 'insalate') return this.insalate.length > 0;
    return false;
  },
  getAllergeni(item) {
    if (!item) return '';
    const locale = this.$i18n.locale;
    if (locale === 'en') return item.allergeniEn || item.allergeni;
    if (locale === 'es') return item.allergeniEs || item.allergeni;
    return item.allergeni;
  },
  goBack() {
    let stored = localStorage.getItem('ordineAttuale');
    if (stored) {
      let parsed = JSON.parse(stored);
      if (parsed.sala) {
        this.$router.push({
          name: "VisualizzaSala",
          params: {
            nome: parsed.sala,
            numero: parsed.numero,
            sale: parsed.sale,
            numeroSale: parsed.numeroSale
          }
        });
        localStorage.removeItem('ordineAttuale');
        return;
      }
    }
    this.$router.push({ name: "Sala" });
  }

  },
  

  beforeMount() {
      if(!this.position){
        this.position = localStorage.getItem('tavolo');
      }
        this.displayMenu();
        this.socketConnect();
        this.fetchDeliveryPlatforms();
    },
}
</script>

<style scoped>
.con-menu{
  overflow-y: scroll;
  height: 100vh;
  background-color: #f8f9fa;
  font-family: 'Inter', sans-serif;
  padding-bottom: 50px;
}

.menu {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.txt {
  font-size: 2rem;
  font-weight: 800;
  color: #2c3e50;
  margin: 30px 20px 15px;
  text-transform: capitalize;
  border-bottom: 2px solid #eaeaea;
  padding-bottom: 10px;
}
.first {
  margin-top: 10vh;
}

.cont-menu {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
  padding: 0 20px;
}

.card {
  height: 100%;
  border: none;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.05);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0,0,0,0.12);
}

.card-body {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  padding: 20px;
}

.card-title {
  font-weight: 700;
  font-size: 1.25rem;
  color: #333;
  margin-bottom: 8px;
}

.card-text {
  color: #666;
  font-size: 0.95rem;
  margin-bottom: 15px;
  flex-grow: 1;
}

.prezzo-text {
  font-weight: 700;
  font-size: 1.15rem;
  color: #e74c3c;
  margin-bottom: 0px;
}

.fot {
  margin-top: auto;
  padding-top: 15px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.description-container {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1), margin-bottom 0.4s ease, opacity 0.3s ease;
  opacity: 0;
  margin-bottom: 0;
}

.description-container.expanded {
  max-height: 300px; /* Increased to accommodate allergens */
  opacity: 1;
  margin-bottom: 15px;
}

.allergeni-info {
  margin-top: 10px;
  font-size: 0.85rem;
  color: #e67e22;
  border-top: 1px solid rgba(0,0,0,0.05);
  padding-top: 8px;
}

.allergeni-info strong {
  color: #d35400;
}

.card-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}

.btn-info-toggle {
  background: none;
  border: none;
  color: #3498db;
  cursor: pointer;
  font-size: 1.1rem;
  padding: 5px;
  transition: transform 0.3s ease, color 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-info-toggle:hover {
  color: #2980b9;
  transform: scale(1.1);
}

.btn-info-toggle i {
  transition: transform 0.3s ease;
}

.order {
  position: fixed;
  top: 0px;
  left: 0;
  width: 100vw;
  background: rgba(44, 62, 80, 0.92);
  color: #ecf0f1;
  z-index: 2000;
  padding: 6px 15px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.25);
  backdrop-filter: blur(15px);
  border-bottom: 3px solid #f1c40f;
  transition: transform 0.3s ease;
}

.order > span {
  font-size: 0.9rem;
  font-weight: 800;
  cursor: pointer;
  display: inline-block;
  margin-bottom: 5px;
  color: #f1c40f;
  text-transform: uppercase;
  letter-spacing: 1.5px;
}

.check-cont {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  overflow-x: auto;
  justify-content: flex-start;
  gap: 12px;
  background: rgba(255,255,255,0.08);
  padding: 8px;
  border-radius: 8px;
  scrollbar-width: none;
}
.check-cont::-webkit-scrollbar { display: none; }

.form-check-label {
  margin-left: 5px;
  font-weight: 500;
  cursor: pointer;
}

.vis-ordine {
  margin-top: 15px;
  max-height: 60vh;
  overflow-y: auto;
  border-top: 1px solid rgba(255,255,255,0.2);
  padding-top: 15px;
}

.riepilogo {
  margin-bottom: 10px;
  background: rgba(255,255,255,0.05);
  padding: 10px;
  border-radius: 8px;
}

.con-piatti {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.nome {
  font-weight: 600;
  font-size: 1.1rem;
}

.aggiunte, .senza {
  font-size: 0.9rem;
  font-style: italic;
  opacity: 0.9;
}
.aggiunte { color: #2ecc71; }
.senza { color: #e74c3c; }

.quantita {
  font-size: 1rem;
  color: #bdc3c7;
}

.prezzo-tot {
  font-weight: bold;
  font-size: 1.1rem;
  color: #f1c40f;
  margin-left: auto;
}

.btn-success {
  background-color: #2ecc71;
  border-color: #2ecc71;
}
.btn-success:hover {
  background-color: #27ae60;
  border-color: #27ae60;
}

.btn-outline-success {
  color: #2ecc71;
  border-color: #2ecc71;
}
.btn-outline-success:hover {
  background-color: #2ecc71;
  color: white;
}

.btn {
  border-radius: 8px;
  font-weight: 600;
  letter-spacing: 0.5px;
  padding: 6px 12px;
}

.back {
  border-radius: 50% !important;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px !important;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  background-color: white;
  color: #333;
  border: none;
  text-decoration: none;
}
.back:hover {
  background-color: #f1f1f1;
}

.cont-back {
  position: absolute;
  top: 15px;
  left: 15px;
  z-index: 101;
}

.error-message {
  position: fixed;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(231, 76, 60, 0.95);
  color: white;
  padding: 12px 25px;
  border-radius: 50px;
  z-index: 1001;
  box-shadow: 0 4px 15px rgba(0,0,0,0.2);
  font-weight: 600;
  backdrop-filter: blur(5px);
  animation: slideUp 0.3s ease-out;
}

@keyframes slideUp {
  from { transform: translate(-50%, 20px); opacity: 0; }
  to { transform: translate(-50%, 0); opacity: 1; }
}

.dish-img {
  width: 100%;
  height: 180px;
  object-fit: cover;
  border-radius: 12px 12px 0 0;
}

/* Category Filter Bar Styles */
.category-filter-container {
  position: sticky;
  top: -3px; /* Sit right below the compact header */
  z-index: 1000;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(20px);
  padding: 15px 0;
  margin: 10px 0 20px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
  border-bottom: 1px solid rgba(0,0,0,0.08);
  transition: all 0.3s ease;
}

.category-filter {
  display: flex;
  overflow-x: auto;
  gap: 12px;
  padding: 0 20px;
  scrollbar-width: none;
  -ms-overflow-style: none;
  justify-content: flex-start;
}

.category-filter::-webkit-scrollbar {
  display: none;
}

.category-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 65px;
  height: 65px;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  padding: 10px;
  border-radius: 18px;
  background: #f8f9fa;
  border: 1px solid rgba(0,0,0,0.05);
  color: #2c3e50;
}

.category-item:hover {
  transform: translateY(-3px);
  background-color: white;
  box-shadow: 0 8px 15px rgba(0,0,0,0.1);
}

.category-item.active {
  background: linear-gradient(135deg, #2ecc71 0%, #27ae60 100%);
  color: white;
  box-shadow: 0 10px 20px rgba(46, 204, 113, 0.4);
  border: none;
  transform: scale(1.05);
}

.category-item.active .cat-icon i {
  color: white;
}

.cat-icon {
  font-size: 1.3rem;
  margin-bottom: 4px;
}

.cat-icon i {
  color: #2ecc71;
  transition: all 0.3s ease;
}

.cat-label {
  font-size: 0.6rem;
  font-weight: 800;
  text-align: center;
  white-space: nowrap;
  letter-spacing: 0.2px;
  text-transform: uppercase;
}

.first {
  margin-top: 10px;
}

@media (max-width: 768px) {
  .category-filter-container {
    top: -3px;
    padding: 8px 0;
  }
  .category-item {
    min-width: 50px;
    height: 50px;
    border-radius: 12px;
    padding: 5px;
  }
  .cat-label {
    display: none;
  }
  .cat-icon {
    margin-bottom: 0;
    font-size: 1.2rem;
  }
  .txt {
    font-size: 1.4rem;
    margin: 20px 15px 10px;
  }
}

.custom-touch-check {
  display: flex;
  align-items: center;
  padding: 10px 14px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  transition: background-color 0.2s, border-color 0.2s;
}
.custom-touch-check:hover {
  background-color: #eef2f7;
  border-color: #ced4da;
}
.custom-touch-check .form-check-input {
  width: 1.25em;
  height: 1.25em;
  cursor: pointer;
}
.custom-touch-check .form-check-label {
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;
  color: #333;
  user-select: none;
  width: 100%;
}
.pointer {
  cursor: pointer;
}

/* Full-screen order summary modal */
.fullscreen-order-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(15, 23, 42, 0.85);
  backdrop-filter: blur(10px);
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  animation: fadeInModal 0.25s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes fadeInModal {
  from { opacity: 0; transform: scale(0.97); }
  to { opacity: 1; transform: scale(1); }
}

.fullscreen-order-modal {
  width: 95vw;
  height: 92vh;
  max-width: 1300px;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 25px 60px -15px rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.fullscreen-modal-header {
  background: #1e293b;
  color: #ffffff;
  padding: 20px 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 2px solid #334155;
}

.fullscreen-modal-header .header-title {
  display: flex;
  align-items: center;
}

.fullscreen-modal-header .header-title h2 {
  margin: 0;
  font-size: 1.8rem;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: 0.5px;
}

.fullscreen-modal-header .header-title i {
  font-size: 1.8rem;
  color: #2ecc71;
}

.header-info-badges {
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
}

.info-badge {
  background: #334155;
  color: #f8fafc;
  padding: 6px 14px;
  border-radius: 30px;
  font-size: 1.1rem;
  font-weight: 500;
}

.info-badge strong {
  color: #2ecc71;
}

.info-badge.delivery {
  background: #0284c7;
  color: #ffffff;
}

.btn-close-modal {
  background: rgba(255, 255, 255, 0.1);
  border: none;
  color: #ffffff;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-close-modal:hover {
  background: #ef4444;
  color: #ffffff;
  transform: rotate(90deg);
}

.fullscreen-modal-body {
  flex: 1;
  overflow-y: auto;
  padding: 25px 30px;
  background: #f8fafc;
}

.empty-order-msg {
  text-align: center;
  padding: 60px 20px;
  color: #64748b;
  font-size: 1.3rem;
}

.order-items-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.order-summary-card {
  background: #ffffff;
  border-radius: 14px;
  padding: 16px 22px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
  border: 1px solid #e2e8f0;
  transition: all 0.2s ease;
}

.order-summary-card:hover {
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
  border-color: #cbd5e1;
}

.item-main-info {
  display: flex;
  align-items: center;
  gap: 18px;
}

.item-course-badge {
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
  color: #ffffff;
  font-size: 1.1rem;
  font-weight: 700;
  padding: 10px 14px;
  border-radius: 10px;
  min-width: 50px;
  text-align: center;
}

.item-details {
  flex: 1;
  text-align: left;
}

.item-name {
  margin: 0 0 4px 0;
  font-size: 1.4rem;
  font-weight: 700;
  color: #1e293b;
}

.item-customizations {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  font-size: 1.1rem;
}

.additions-tag {
  color: #16a34a;
  font-weight: 600;
}

.removals-tag {
  color: #dc2626;
  font-weight: 600;
}

.item-note-input {
  max-width: 500px;
}

.item-quantity-controls {
  display: flex;
  align-items: center;
  background: #f1f5f9;
  border-radius: 10px;
  padding: 4px;
  border: 1px solid #cbd5e1;
}

.btn-qty {
  width: 38px;
  height: 38px;
  border: none;
  background: #ffffff;
  color: #1e293b;
  border-radius: 8px;
  font-size: 1.3rem;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  transition: all 0.15s ease;
}

.btn-qty:hover {
  background: #2ecc71;
  color: white;
}

.qty-display {
  min-width: 40px;
  text-align: center;
  font-size: 1.3rem;
  font-weight: 700;
  color: #0f172a;
}

.item-pricing {
  text-align: right;
  min-width: 120px;
}

.unit-price {
  font-size: 0.95rem;
  color: #64748b;
}

.total-price {
  font-size: 1.4rem;
  font-weight: 800;
  color: #16a34a;
}

.btn-delete-item {
  background: #fee2e2;
  color: #ef4444;
  border: none;
  width: 42px;
  height: 42px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-delete-item:hover {
  background: #ef4444;
  color: #ffffff;
}

.fullscreen-modal-footer {
  background: #ffffff;
  border-top: 2px solid #e2e8f0;
  padding: 20px 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.order-grand-total {
  text-align: left;
}

.total-label {
  font-size: 1.1rem;
  color: #64748b;
  font-weight: 600;
}

.total-amount {
  font-size: 2.3rem;
  font-weight: 800;
  color: #16a34a;
  line-height: 1.1;
}

.action-buttons {
  display: flex;
  gap: 16px;
}

.btn-cancel {
  padding: 14px 28px;
  border-radius: 12px;
  border: 2px solid #cbd5e1;
  background: #ffffff;
  color: #475569;
  font-size: 1.2rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
}

.btn-cancel:hover {
  background: #f1f5f9;
  border-color: #94a3b8;
  color: #1e293b;
}

.btn-submit-order {
  padding: 14px 36px;
  border-radius: 12px;
  border: none;
  background: linear-gradient(135deg, #2ecc71 0%, #27ae60 100%);
  color: #ffffff;
  font-size: 1.3rem;
  font-weight: 800;
  cursor: pointer;
  box-shadow: 0 10px 25px rgba(46, 204, 113, 0.4);
  transition: all 0.25s ease;
  display: flex;
  align-items: center;
}

.btn-submit-order:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 14px 30px rgba(46, 204, 113, 0.5);
  background: linear-gradient(135deg, #34d399 0%, #059669 100%);
}

.btn-submit-order:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  box-shadow: none;
}
</style>